import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  registerSchoolLeaveDetail(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/leave/management", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
